import {
  Backdrop,
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  Input,
  InputLabel,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import WebcamDemo from '../videoDemo/webcamDetection';
import '../views/tablestyle.css';
import { toast } from 'react-toastify';
import { endpoint } from '../../resource/Constant';
import { DataGrid } from '@mui/x-data-grid';

function CreateInterview() {
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('authToken');
  const navigate = useNavigate();
  const [formstate, setForm] = useState({
    technology: undefined,
    experience: undefined,
    important_topics: undefined
  });
  const [allInterviews, setAllIterviews] = useState([]);
  const onTechnologyChange = (event) => {
    setForm((e) => ({
      technology: event.target.value,
      experience: e.experience,
      important_topics: e.important_topics
    }));
  };

  const columns = [
    { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'technology', headerName: 'Technology', flex: 2 },
    { field: 'experience', headerName: 'Experience', flex: 1 },
    {
      field: 'end_time',
      headerName: 'Validity',
      flex: 2,
      renderCell: (interview) => {
        return <>{interview.row.end_time ? new Date(interview.row.end_time).toLocaleString() : 'Not Available'}</>;
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 2,
      renderCell: (interview) => {
        return (
          <>
            {interview.row.interview_status == 2 && (
              <Button
                sx={{
                  color: 'rgb(27, 38, 59)',
                  backgroundColor: '#ed4068',
                  '&:hover': {
                    backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%))',
                    color: 'rgb(224, 225, 221)',
                    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)'
                  }
                }}
                onClick={() => {
                  navigate(`/result/${interview.row.id}`);
                }}
              >
                Show Result
              </Button>
            )}
            {interview.row.interview_status == 0 && (
              <Button
                sx={{
                  color: '#FFFFFF',
                  backgroundColor: '#ed4068',
                  '&:hover': {
                    backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%))',
                    color: 'rgb(224, 225, 221)',
                    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)'
                  }
                }}
                onClick={() => {
                  navigate(`/startinterview/${interview.row.id}/${interview.row.user_email}/${interview.row.password}`);
                }}
              >
                Start
              </Button>
            )}
            {interview.row.interview_status == 1 && (
              <Button
                sx={{
                  color: '#FFFFFF',
                  backgroundColor: '#ed4068',
                  '&:hover': {
                    backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%))',
                    color: 'rgb(224, 225, 221)',
                    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)'
                  }
                }}
                onClick={() => {
                  getAllInterviews();
                  forceDeclareRusult(interview.row.id);
                }}
              >
                Reload
              </Button>
            )}
          </>
        );
      }
    }
  ];
  const onExperinceChange = (event) => {
    setForm((e) => ({
      technology: e.technology,
      experience: event.target.value,
      important_topics: e.important_topics
    }));
  };
  const onimportantTopChange = (event) => {
    setForm((e) => ({
      technology: e.technology,
      experience: e.experience,
      important_topics: event.target.value
    }));
  };

  const getAllInterviews = () => {
    setLoading(true);
    axios
      .get(endpoint + `/api/company/interview/?token=${token}`)
      .then((res) => {
        if (res?.status == 200) {
          setAllIterviews(res.data.reverse());
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const forceDeclareRusult = (interviewid) => {
    axios.get(endpoint + `/api/interview/declareresult`, {
      params: { interview_id: interviewid }
    });
  };

  const addInterview = (data) => {
    setLoading(true);
    axios
      .post(endpoint + `/api/interview/?token=${token}`, data)
      .then((res) => {
        if (res.status == 200) {
          toast.success(
            `Interview Added!
You can attempt it within the next 10 days. `,
            {
              position: toast.POSITION.TOP_RIGHT,
              toastId: 'success1'
            }
          );
          getAllInterviews();
          setLoading(false);
        } else {
          setLoading(false);
          toast.error(`Issue creating interview,Please Try again later.`, {
            position: toast.POSITION.TOP_RIGHT,
            toastId: 'error1'
          });
        }
      })
      .catch(() => {
        setLoading(false);
        toast.error(`Issue creating interview`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
      });
  };
  const toISOString = (d) => {
    return (
      [d.getFullYear(), padLeft(d.getMonth() + 1), padLeft(d.getDate())].join('-') +
      'T' +
      [padLeft(d.getHours()), padLeft(d.getMinutes()), padLeft(d.getSeconds())].join(':')
    );
  };
  const padLeft = (num) => {
    var len = String(num).length;
    return len == 1 ? '0' + num : num;
  };

  const submitData = (e) => {
    e.preventDefault();
    if (!formstate.technology || !formstate.experience || !formstate.important_topics) {
      alert('wrong input');
      return;
    }
    if (formstate.experience < 0) {
      alert('Enter valid experience.');
      return;
    }
    const today = new Date().toISOString();
    const data = {
      experience: formstate.experience,
      //dummy value
      // endTime: today,
      // id: 1,
      // interview_status: false,
      //dummy value
      // startTime: today,
      technology: formstate.technology,
      important_points: formstate.important_topics,
      work_n_xlid: 0,
      user_email: 'exact' + new Date().getTime() + '@gmail.com'
    };
    addInterview(data);
  };

  useEffect(() => {
    getAllInterviews();
  }, []);
  return (
    <Grid style={{ minHeight: '100vh', padding: '20px', overflowY: 'auto' }}>
      <Grid>
        <Typography variant="h5" color="#FFFFFF">
          Create Interview
        </Typography>
        <form onSubmit={submitData}>
          <FormControl>
            <InputLabel htmlFor="technology" style={{ color: '#CCCCCC' }}>
              Technology
            </InputLabel>
            <Input
              id="technology"
              onChange={onTechnologyChange}
              value={formstate.technology}
              aria-describedby="my-helper-text"
              style={{ color: '#FFFFFF' }}
            />
          </FormControl>
          <FormControl>
            <InputLabel htmlFor="experience" style={{ color: '#CCCCCC' }}>
              Experience
            </InputLabel>
            <Input
              type="number"
              id="experience"
              value={formstate.experience}
              aria-describedby="my-helper-text"
              onChange={onExperinceChange}
              style={{ color: '#FFFFFF' }}
            />
            <FormHelperText id="important-topics-helper" style={{ color: '#B0B0B0' }}>
              Please enter value in years.
            </FormHelperText>
          </FormControl>
          <FormControl>
            <InputLabel htmlFor="important-topics" style={{ color: '#CCCCCC' }}>
              Important-Topics
            </InputLabel>
            <Input
              id="important-topics"
              value={formstate.important_topics}
              aria-describedby="important-topics-helper"
              onChange={onimportantTopChange}
              style={{ color: '#FFFFFF' }}
            />
            <FormHelperText id="important-topics-helper" style={{ color: '#B0B0B0' }}>
              Please enter comma-separated values.
            </FormHelperText>
          </FormControl>
          <Grid paddingTop={'10px'}>
            <Button
              type="submit"
              sx={{
                backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%))',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#555555',
                  color: 'white',
                  boxShadow: '0 4px 4px 2px rgba(0, 0, 0, 0.2)'
                }
              }}
              variant="contained"
            >
              Create
            </Button>
          </Grid>
        </form>
      </Grid>
      <Grid style={{ padding: '30px', overflowY: 'auto' }}>
        <DataGrid
          initialState={{
            pagination: {
              paginationModel: { pageSize: 10, page: 0 }
            }
          }}
          columns={columns}
          rows={allInterviews}
          sx={{
            boxShadow: 2,
            minWidth: '500px',
            '& .MuiDataGrid-row': {
              borderBottom: '1px solid white',
              color: '#FFFFFF'
            },
            '&  .MuiDataGrid-columnHeader': {
              background: '#8abfc2',
              color: '#000000'
            },
            '&  .MuiTablePagination-root': {
              fontSize: '1.2rem',
              fontFamily: 'Arial, sans-serif',
              color: '#ffffff'
            }
          }}
        />
      </Grid>
      <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Grid>
  );
}

export default CreateInterview;
